import { useCommonWebsocket } from '@common/api/ws/hooks/useCommonWebsocket';
export var useNotificationSocket = function (cb) {
    useCommonWebsocket('notification', cb);
};
